import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import Container from '@material-ui/core/Container';
import { withStyles } from '@material-ui/core/styles';
import { changeHeaderName } from '../../actions/dashboardActions';
import { clearSucessMsg, clearErrorMsg } from '../../actions/adminActions';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import AddTermsAndConditionsForm from './AddTermsAndConditionsForm';

const styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  container: {
    width: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(4),
  },
  snackClose: {
    padding: theme.spacing(0.5),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
});


class TermsAndConditions extends Component {

  constructor() {
    super();
    this.state = {
      snackOpen: false,
      sucessMsg: null,
      errorMsg: null,
      currentRecord: null,
      isBusy: false,
    };
  }

  componentDidMount() {
    this.props.changeHeaderName("Terms & Conditions");
    this.loadCurrent();
  }

  handleSnackClose = () => {
    this.setState({ snackOpen: false, sucessMsg: null, errorMsg: null });
  }

  showSuccess = (msg) => {
    this.setState({ sucessMsg: msg, snackOpen: true, errorMsg: null });
  }

  showError = (msg) => {
    this.setState({ errorMsg: msg, snackOpen: true, sucessMsg: null });
  }

  loadCurrent = async () => {
    this.setState({ isBusy: true });
    try {
      const response = await axios.get('/api/termsandconditions/current');
      const data = response.data && response.data._id ? response.data : null;
      this.setState({ currentRecord: data, isBusy: false });
    } catch (e) {
      this.setState({ isBusy: false });
      this.showError('Error loading Terms & Conditions.');
    }
  }

  handleCreate = async (formValues) => {
    this.setState({ isBusy: true });
    try {
      const response = await axios.post('/api/termsandconditions', formValues);
      this.setState({ currentRecord: response.data, isBusy: false });
      this.showSuccess('Terms & Conditions saved successfully.');
    } catch (e) {
      this.setState({ isBusy: false });
      this.showError('Error while saving Terms & Conditions.');
    }
  }

  handleUpdate = async (id, formValues) => {
    this.setState({ isBusy: true });
    try {
      const response = await axios.put(`/api/termsandconditions/${id}`, formValues);
      this.setState({ currentRecord: response.data, isBusy: false });
      this.showSuccess('Terms & Conditions updated successfully.');
    } catch (e) {
      this.setState({ isBusy: false });
      this.showError('Error while updating Terms & Conditions.');
    }
  }

  handleDelete = async (id) => {
    this.setState({ isBusy: true });
    try {
      await axios.delete(`/api/termsandconditions/${id}`);
      this.setState({ currentRecord: null, isBusy: false });
      this.showSuccess('Terms & Conditions deleted successfully.');
    } catch (e) {
      this.setState({ isBusy: false });
      this.showError('Error while deleting Terms & Conditions.');
    }
  }

  handleClear = () => {
    this.setState({ currentRecord: null });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.admin.sucessMsg !== null) {
      this.setState({ sucessMsg: this.props.admin.sucessMsg, snackOpen: true });
      this.props.clearSucessMsg();
    } else if (this.props.admin.errorMsg !== null) {
      this.setState({ errorMsg: this.props.admin.errorMsg, snackOpen: true });
      this.props.clearErrorMsg();
    }
  }

  render() {
    const { classes, dashboard } = this.props;
    const { currentRecord, isBusy } = this.state;
    let muiAlert = null;

    if (this.state.sucessMsg) {
      muiAlert = <MuiAlert elevation={6} variant="filled" onClose={this.handleSnackClose} severity="success">
        {this.state.sucessMsg}
      </MuiAlert>
    } else if (this.state.errorMsg) {
      muiAlert = <MuiAlert elevation={6} variant="filled" onClose={this.handleSnackClose} severity="error">
        {this.state.errorMsg}
      </MuiAlert>
    }

    const formKey = currentRecord && currentRecord._id ? currentRecord._id : 'new';

    return (
      <Container maxWidth="lg">
        <div className={classes.appBarSpacer} />
        <Container>
          <AddTermsAndConditionsForm
            key={formKey}
            initialValues={currentRecord || {}}
            editMode={!!(currentRecord && currentRecord._id)}
            onCreate={this.handleCreate}
            onUpdate={this.handleUpdate}
            onDelete={this.handleDelete}
            onClear={this.handleClear}
          />
        </Container>

        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open={this.state.snackOpen}
          autoHideDuration={6000}
          onClose={this.handleSnackClose}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}>
          {muiAlert}
        </Snackbar>
        <Backdrop className={classes.backdrop} open={isBusy || (dashboard && dashboard.isFetching)}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    dashboard: state.dashboard,
    user: state.auth.user,
    admin: state.admin
  }
};
export default connect(mapStateToProps, {
  changeHeaderName,
  clearSucessMsg,
  clearErrorMsg
})(withStyles(styles)(TermsAndConditions));
